// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientConsents_root__20ApX","consentsList":"PatientConsents_consentsList__1zZKE","consentsListEmpty":"PatientConsents_consentsListEmpty__3T-je"};